import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const fmt = n => `$${(n||0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;
const hoy = new Date().toISOString().split('T')[0];
const mesActual = MESES[new Date().getMonth()];
const anioActual = new Date().getFullYear();

export default function Empleados() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('resumen');
  const [empleados, setEmpleados] = useState([]);
  const [sueldos, setSueldos] = useState([]);
  const [asistencias, setAsistencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exito, setExito] = useState('');

  // Forms
  const [formEmp, setFormEmp] = useState({ nombre:'', cargo:'', sueldo_base:'', fecha_ingreso:'', telefono:'' });
  const [formSueldo, setFormSueldo] = useState({ empleado_id:'', mes:mesActual, anio:anioActual, sueldo_base:'', presentismo:0, horas_extra:0, descuentos:0, observaciones:'' });
  const [formAsist, setFormAsist] = useState({ empleado_id:'', fecha:hoy, presente:true, llego_tarde:false, horas_extra:0, observaciones:'' });
  const [guardando, setGuardando] = useState(false);

  useEffect(() => { cargarDatos(); }, []);

  async function cargarDatos() {
    setLoading(true);
    const [{ data: emps }, { data: suel }, { data: asist }] = await Promise.all([
      supabase.from('empleados').select('*').eq('activo', true).order('nombre'),
      supabase.from('sueldos').select('*, empleados(nombre)').order('anio', { ascending:false }).order('mes'),
      supabase.from('asistencia').select('*, empleados(nombre)').order('fecha', { ascending:false }),
    ]);
    setEmpleados(emps || []);
    setSueldos(suel || []);
    setAsistencias(asist || []);
    setLoading(false);
  }

  async function guardarEmpleado() {
    if (!formEmp.nombre || !formEmp.cargo || !formEmp.sueldo_base) {
      alert('Completá nombre, cargo y sueldo base');
      return;
    }
    setGuardando(true);
    const { error } = await supabase.from('empleados').insert({
      nombre: formEmp.nombre,
      cargo: formEmp.cargo,
      sueldo_base: parseFloat(formEmp.sueldo_base),
      fecha_ingreso: formEmp.fecha_ingreso || null,
      telefono: formEmp.telefono || null,
    });
    setGuardando(false);
    if (error) { alert('Error: ' + error.message); return; }
    mostrarExito('¡Empleado agregado correctamente!');
    setFormEmp({ nombre:'', cargo:'', sueldo_base:'', fecha_ingreso:'', telefono:'' });
    cargarDatos();
    setTab('resumen');
  }

  async function guardarSueldo() {
    if (!formSueldo.empleado_id || !formSueldo.sueldo_base) {
      alert('Seleccioná empleado y completá el sueldo base');
      return;
    }
    setGuardando(true);
    const { error } = await supabase.from('sueldos').insert({
      empleado_id: formSueldo.empleado_id,
      mes: formSueldo.mes,
      anio: parseInt(formSueldo.anio),
      sueldo_base: parseFloat(formSueldo.sueldo_base),
      presentismo: parseFloat(formSueldo.presentismo) || 0,
      horas_extra: parseFloat(formSueldo.horas_extra) || 0,
      descuentos: parseFloat(formSueldo.descuentos) || 0,
      observaciones: formSueldo.observaciones,
    });
    setGuardando(false);
    if (error) { alert('Error: ' + error.message); return; }
    mostrarExito('¡Sueldo registrado correctamente!');
    setFormSueldo({ empleado_id:'', mes:mesActual, anio:anioActual, sueldo_base:'', presentismo:0, horas_extra:0, descuentos:0, observaciones:'' });
    cargarDatos();
    setTab('sueldos');
  }

  async function guardarAsistencia() {
    if (!formAsist.empleado_id || !formAsist.fecha) {
      alert('Seleccioná empleado y fecha');
      return;
    }
    setGuardando(true);
    const { error } = await supabase.from('asistencia').insert({
      empleado_id: formAsist.empleado_id,
      fecha: formAsist.fecha,
      presente: formAsist.presente,
      llego_tarde: formAsist.llego_tarde,
      horas_extra: parseFloat(formAsist.horas_extra) || 0,
      observaciones: formAsist.observaciones,
    });
    setGuardando(false);
    if (error) { alert('Error: ' + error.message); return; }
    mostrarExito('¡Asistencia registrada!');
    setFormAsist({ empleado_id:'', fecha:hoy, presente:true, llego_tarde:false, horas_extra:0, observaciones:'' });
    cargarDatos();
    setTab('asistencia');
  }

  async function marcarPagado(sueldoId) {
    await supabase.from('sueldos').update({ pagado:true, fecha_pago:hoy }).eq('id', sueldoId);
    cargarDatos();
  }

  function mostrarExito(msg) {
    setExito(msg);
    setTimeout(() => setExito(''), 3000);
  }

  function totalSueldosMes() {
    return sueldos.filter(s => s.mes === mesActual && s.anio === anioActual)
      .reduce((sum, s) => sum + (s.total||0), 0);
  }

  function asistenciasDelMes(empleadoId) {
    const inicio = `${anioActual}-${String(new Date().getMonth()+1).padStart(2,'0')}-01`;
    return asistencias.filter(a => a.empleado_id === empleadoId && a.fecha >= inicio);
  }

  const lbl = { fontSize:12, color:'#888', fontWeight:'bold', display:'block', marginBottom:4 };
  const inp = { padding:'8px 10px', border:'1px solid #ddd', borderRadius:8, fontSize:14, outline:'none', width:'100%', boxSizing:'border-box' };

  const tabs = [
    ['resumen',    '👥 Empleados'],
    ['sueldos',    '💰 Sueldos'],
    ['asistencia', '📆 Asistencia'],
    ['nuevo-emp',  '➕ Nuevo Empleado'],
    ['nuevo-sueldo','💵 Registrar Sueldo'],
    ['nueva-asist','✅ Cargar Asistencia'],
  ];

  return (
    <div style={{ minHeight:'100vh', background:'#F2F3F4' }}>

      {/* Header */}
      <div style={{ background:'#1B2631', padding:'16px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <h1 style={{ color:'#fff', margin:0, fontSize:20 }}>👷 Empleados</h1>
          <p style={{ color:'#aaa', margin:'2px 0 0', fontSize:12 }}>Sueldos y asistencia</p>
        </div>
        <button onClick={() => navigate('/dashboard')}
          style={{ background:'transparent', border:'1px solid #555', color:'#aaa', padding:'8px 16px', borderRadius:8, cursor:'pointer' }}>
          ← Volver
        </button>
      </div>

      <div style={{ maxWidth:900, margin:'0 auto', padding:24 }}>

        {exito && (
          <div style={{ background:'#D5F5E3', border:'1px solid #27AE60', borderRadius:8, padding:12, marginBottom:16, color:'#1E8449', fontWeight:'bold', textAlign:'center' }}>
            ✅ {exito}
          </div>
        )}

        {/* KPI */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
          {[
            { label:'👥 Empleados activos', valor: empleados.length, esNum:true, color:'#2471A3' },
            { label:'💰 Sueldos este mes',  valor: fmt(totalSueldosMes()), esNum:false, color:'#6C3483' },
            { label:'✅ Sueldos pagados',   valor: sueldos.filter(s=>s.mes===mesActual&&s.anio===anioActual&&s.pagado).length, esNum:true, color:'#27AE60' },
          ].map((k,i) => (
            <div key={i} style={{ background:'#fff', borderRadius:12, padding:16, textAlign:'center', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
              <div style={{ fontSize:11, color:'#888', marginBottom:4 }}>{k.label}</div>
              <div style={{ fontSize:22, fontWeight:'bold', color:k.color }}>{k.valor}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
          {tabs.map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)}
              style={{ padding:'8px 14px', borderRadius:8, border:'none', cursor:'pointer', fontWeight:'bold', fontSize:12,
                background: tab===key ? '#6C3483' : '#fff',
                color: tab===key ? '#fff' : '#555',
                boxShadow:'0 2px 6px rgba(0,0,0,0.08)'
              }}>
              {label}
            </button>
          ))}
        </div>

        {/* ── RESUMEN EMPLEADOS ── */}
        {tab === 'resumen' && (
          <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 16px', fontSize:16, color:'#1B2631' }}>👥 Equipo</h2>
            {loading ? <div style={{ textAlign:'center', padding:30, color:'#888' }}>Cargando...</div>
            : empleados.length === 0 ? <div style={{ textAlign:'center', padding:30, color:'#888' }}>No hay empleados. Agregá uno con "➕ Nuevo Empleado"</div>
            : empleados.map(e => {
              const asistMes = asistenciasDelMes(e.id);
              const presentes = asistMes.filter(a => a.presente).length;
              const faltas = asistMes.filter(a => !a.presente).length;
              const sueldo = sueldos.find(s => s.empleado_id === e.id && s.mes === mesActual && s.anio === anioActual);
              return (
                <div key={e.id} style={{ borderBottom:'1px solid #f5f5f5', padding:'16px 0', display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:12 }}>
                  <div>
                    <div style={{ fontSize:15, fontWeight:'bold', color:'#1B2631' }}>👤 {e.nombre}</div>
                    <div style={{ fontSize:13, color:'#888', marginTop:2 }}>{e.cargo}</div>
                    <div style={{ fontSize:12, color:'#aaa', marginTop:2 }}>Sueldo base: {fmt(e.sueldo_base)}</div>
                    {e.telefono && <div style={{ fontSize:12, color:'#aaa' }}>📞 {e.telefono}</div>}
                  </div>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontSize:12, color:'#555', marginBottom:4 }}>
                      Este mes: <span style={{ color:'#27AE60', fontWeight:'bold' }}>{presentes} presentes</span>
                      {faltas > 0 && <span style={{ color:'#C0392B', fontWeight:'bold' }}> · {faltas} faltas</span>}
                    </div>
                    {sueldo ? (
                      <div>
                        <div style={{ fontSize:14, fontWeight:'bold', color: sueldo.pagado ? '#27AE60' : '#E67E22' }}>
                          {sueldo.pagado ? '✅ Sueldo pagado' : '⏳ Sueldo pendiente'}
                        </div>
                        <div style={{ fontSize:13, color:'#555' }}>{fmt(sueldo.total)}</div>
                        {!sueldo.pagado && (
                          <button onClick={() => marcarPagado(sueldo.id)}
                            style={{ marginTop:4, padding:'4px 12px', background:'#27AE60', color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:'bold' }}>
                            💰 Marcar pagado
                          </button>
                        )}
                      </div>
                    ) : (
                      <div style={{ fontSize:12, color:'#aaa' }}>Sin sueldo cargado este mes</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* ── SUELDOS ── */}
        {tab === 'sueldos' && (
          <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 16px', fontSize:16, color:'#1B2631' }}>💰 Historial de Sueldos</h2>
            {sueldos.length === 0 ? <div style={{ textAlign:'center', padding:30, color:'#888' }}>No hay sueldos registrados</div>
            : sueldos.map((s, i) => (
              <div key={s.id} style={{ borderBottom:'1px solid #f5f5f5', padding:'12px 0', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:8 }}>
                <div>
                  <div style={{ fontSize:14, fontWeight:'bold', color:'#1B2631' }}>👤 {s.empleados?.nombre}</div>
                  <div style={{ fontSize:12, color:'#888' }}>{s.mes} {s.anio}</div>
                  <div style={{ fontSize:11, color:'#aaa' }}>
                    Base: {fmt(s.sueldo_base)} · Presentismo: {fmt(s.presentismo)} · HS Extra: {fmt(s.horas_extra)} · Desc: {fmt(s.descuentos)}
                  </div>
                  {s.observaciones && <div style={{ fontSize:11, color:'#aaa', fontStyle:'italic' }}>{s.observaciones}</div>}
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:16, fontWeight:'bold', color:'#6C3483' }}>{fmt(s.total)}</div>
                  <div style={{ fontSize:12, marginTop:2 }}>
                    {s.pagado
                      ? <span style={{ color:'#27AE60', fontWeight:'bold' }}>✅ Pagado {s.fecha_pago ? `(${new Date(s.fecha_pago+'T12:00:00').toLocaleDateString('es-AR')})` : ''}</span>
                      : <span style={{ color:'#E67E22', fontWeight:'bold' }}>⏳ Pendiente</span>
                    }
                  </div>
                  {!s.pagado && (
                    <button onClick={() => marcarPagado(s.id)}
                      style={{ marginTop:4, padding:'4px 12px', background:'#27AE60', color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:'bold' }}>
                      💰 Marcar pagado
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── ASISTENCIA ── */}
        {tab === 'asistencia' && (
          <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 16px', fontSize:16, color:'#1B2631' }}>📆 Registro de Asistencia</h2>
            {asistencias.length === 0 ? <div style={{ textAlign:'center', padding:30, color:'#888' }}>No hay registros de asistencia</div>
            : asistencias.slice(0,30).map((a, i) => (
              <div key={a.id} style={{ borderBottom:'1px solid #f5f5f5', padding:'8px 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div>
                  <span style={{ fontSize:13, fontWeight:'bold', color:'#1B2631' }}>👤 {a.empleados?.nombre}</span>
                  <span style={{ fontSize:12, color:'#888', marginLeft:8 }}>
                    {new Date(a.fecha+'T12:00:00').toLocaleDateString('es-AR')}
                  </span>
                </div>
                <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                  {a.horas_extra > 0 && <span style={{ fontSize:11, color:'#2471A3' }}>+{a.horas_extra}hs extra</span>}
                  {a.llego_tarde && <span style={{ fontSize:11, color:'#E67E22' }}>⏰ Tarde</span>}
                  <span style={{ fontSize:13, fontWeight:'bold', color: a.presente ? '#27AE60' : '#C0392B' }}>
                    {a.presente ? '✅ Presente' : '❌ Ausente'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── NUEVO EMPLEADO ── */}
        {tab === 'nuevo-emp' && (
          <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 20px', fontSize:16, color:'#1B2631' }}>➕ Agregar Empleado</h2>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={lbl}>Nombre completo *</label>
                <input placeholder="Ej: María González" value={formEmp.nombre} onChange={e => setFormEmp({...formEmp, nombre:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Cargo *</label>
                <input placeholder="Ej: Cocinero, Cajero..." value={formEmp.cargo} onChange={e => setFormEmp({...formEmp, cargo:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Sueldo Base (ARS) *</label>
                <input type="number" placeholder="0" value={formEmp.sueldo_base} onChange={e => setFormEmp({...formEmp, sueldo_base:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Fecha de ingreso</label>
                <input type="date" value={formEmp.fecha_ingreso} onChange={e => setFormEmp({...formEmp, fecha_ingreso:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Teléfono</label>
                <input placeholder="Opcional" value={formEmp.telefono} onChange={e => setFormEmp({...formEmp, telefono:e.target.value})} style={inp} />
              </div>
            </div>
            <button onClick={guardarEmpleado} disabled={guardando}
              style={{ marginTop:20, width:'100%', padding:14, background: guardando ? '#aaa' : '#6C3483', color:'#fff', border:'none', borderRadius:10, fontSize:16, fontWeight:'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
              {guardando ? 'Guardando...' : '💾 Guardar Empleado'}
            </button>
          </div>
        )}

        {/* ── REGISTRAR SUELDO ── */}
        {tab === 'nuevo-sueldo' && (
          <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 20px', fontSize:16, color:'#1B2631' }}>💵 Registrar Sueldo</h2>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={lbl}>Empleado *</label>
                <select value={formSueldo.empleado_id} onChange={e => {
                  const emp = empleados.find(emp => emp.id === e.target.value);
                  setFormSueldo({...formSueldo, empleado_id:e.target.value, sueldo_base: emp?.sueldo_base || ''});
                }} style={inp}>
                  <option value="">Seleccioná...</option>
                  {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre} — {e.cargo}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Mes *</label>
                <select value={formSueldo.mes} onChange={e => setFormSueldo({...formSueldo, mes:e.target.value})} style={inp}>
                  {MESES.map(m => <option key={m}>{m}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Año *</label>
                <input type="number" value={formSueldo.anio} onChange={e => setFormSueldo({...formSueldo, anio:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Sueldo Base (ARS) *</label>
                <input type="number" placeholder="0" value={formSueldo.sueldo_base} onChange={e => setFormSueldo({...formSueldo, sueldo_base:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Presentismo (ARS)</label>
                <input type="number" placeholder="0" value={formSueldo.presentismo} onChange={e => setFormSueldo({...formSueldo, presentismo:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Horas Extra (ARS)</label>
                <input type="number" placeholder="0" value={formSueldo.horas_extra} onChange={e => setFormSueldo({...formSueldo, horas_extra:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Descuentos (ARS)</label>
                <input type="number" placeholder="0" value={formSueldo.descuentos} onChange={e => setFormSueldo({...formSueldo, descuentos:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Total a pagar</label>
                <div style={{ padding:'8px 10px', background:'#F4ECF7', borderRadius:8, fontWeight:'bold', color:'#6C3483', fontSize:16 }}>
                  {fmt((parseFloat(formSueldo.sueldo_base)||0) + (parseFloat(formSueldo.presentismo)||0) + (parseFloat(formSueldo.horas_extra)||0) - (parseFloat(formSueldo.descuentos)||0))}
                </div>
              </div>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={lbl}>Observaciones</label>
                <input placeholder="Opcional..." value={formSueldo.observaciones} onChange={e => setFormSueldo({...formSueldo, observaciones:e.target.value})} style={inp} />
              </div>
            </div>
            <button onClick={guardarSueldo} disabled={guardando}
              style={{ marginTop:20, width:'100%', padding:14, background: guardando ? '#aaa' : '#6C3483', color:'#fff', border:'none', borderRadius:10, fontSize:16, fontWeight:'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
              {guardando ? 'Guardando...' : '💾 Guardar Sueldo'}
            </button>
          </div>
        )}

        {/* ── CARGAR ASISTENCIA ── */}
        {tab === 'nueva-asist' && (
          <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <h2 style={{ margin:'0 0 20px', fontSize:16, color:'#1B2631' }}>✅ Cargar Asistencia</h2>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={lbl}>Empleado *</label>
                <select value={formAsist.empleado_id} onChange={e => setFormAsist({...formAsist, empleado_id:e.target.value})} style={inp}>
                  <option value="">Seleccioná...</option>
                  {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Fecha *</label>
                <input type="date" value={formAsist.fecha} onChange={e => setFormAsist({...formAsist, fecha:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>Horas Extra</label>
                <input type="number" placeholder="0" value={formAsist.horas_extra} onChange={e => setFormAsist({...formAsist, horas_extra:e.target.value})} style={inp} />
              </div>
              <div>
                <label style={lbl}>¿Estuvo presente?</label>
                <div style={{ display:'flex', gap:8, marginTop:6 }}>
                  {[[true,'✅ Sí'],[false,'❌ No']].map(([val, label]) => (
                    <button key={String(val)} onClick={() => setFormAsist({...formAsist, presente:val})}
                      style={{ flex:1, padding:'8px', borderRadius:8, border:'none', cursor:'pointer', fontWeight:'bold',
                        background: formAsist.presente===val ? (val ? '#27AE60' : '#C0392B') : '#eee',
                        color: formAsist.presente===val ? '#fff' : '#555'
                      }}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label style={lbl}>¿Llegó tarde?</label>
                <div style={{ display:'flex', gap:8, marginTop:6 }}>
                  {[[false,'✅ No'],[true,'⏰ Sí']].map(([val, label]) => (
                    <button key={String(val)} onClick={() => setFormAsist({...formAsist, llego_tarde:val})}
                      style={{ flex:1, padding:'8px', borderRadius:8, border:'none', cursor:'pointer', fontWeight:'bold',
                        background: formAsist.llego_tarde===val ? (val ? '#E67E22' : '#27AE60') : '#eee',
                        color: formAsist.llego_tarde===val ? '#fff' : '#555'
                      }}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={lbl}>Observaciones</label>
                <input placeholder="Opcional..." value={formAsist.observaciones} onChange={e => setFormAsist({...formAsist, observaciones:e.target.value})} style={inp} />
              </div>
            </div>
            <button onClick={guardarAsistencia} disabled={guardando}
              style={{ marginTop:20, width:'100%', padding:14, background: guardando ? '#aaa' : '#27AE60', color:'#fff', border:'none', borderRadius:10, fontSize:16, fontWeight:'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
              {guardando ? 'Guardando...' : '💾 Guardar Asistencia'}
            </button>
          </div>
        )}

      </div>
    </div>
  );
}